const commonPath = '/assets/common/'
const basePath = '/assets/cash-cash-assets/'

export const path = {
  imagePath: basePath + 'images/',
  spinePath: basePath + 'spine/',
  fontsPath: basePath + 'fonts/',
  victoryAudioPath: commonPath + 'sounds/',
  spriteSheetCommon: commonPath + 'spriteSheets/',
  sounds: basePath +'sounds/'
}


export const settings = {
  originalWidth: 1920,
  originalHeight: 870,
  currentWidth: 1920,
  currentHeight: 870,
  windowWidth: 1920,
  windowHeight: 870, 
  backgroundColor: 0x000000,
  backgroundAlpha: 1,
  devicePixelRatio: 1.6,
  div: () => document.getElementById('pixi-game'),
  gameResetDelay: {
    won: 12,
    lost: 0
  },
  music: true,
  sound: true,
  vibration: true 
}
